export enum MouldingType {
    Frame = 1,
    Chop = 2,
    Length = 3,
    PhotoFrame_Mirror = 4,
    Rail = 5
}
  